
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 122.88 92.92"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M118.89 37a4.61 4.61 0 10-4.61 4.62 4.6 4.6 0 004.61-4.62zM97.28 10.18l-7 70.42c1.57.19 4 0 4.43-2.48.67-3.78 6.45-62.74 6.45-62.74s1.06-2.78-3.93-5.2zm16.17 36.57s-4 1.17-9.2 2.06L101 80.12s-.44 6.67-5.34 6.67h-5.94l-.07.68s-.74 4.59-4.74 5.19-81.43 0-81.43 0S.21 92.06.07 89s0-66.15 0-66.15A6.62 6.62 0 015.7 18.2c1.78-.23 15.2-2.44 31-5.07l5.28-10a6 6 0 0110.32-.29A5.77 5.77 0 0048.54 1H48a5.87 5.87 0 00-5.2 3.12L3.9 78a5.87 5.87 0 0010.38 5.47l28-53.18v43.92a5.81 5.81 0 005.8 5.79c3.61 0 6-4.51 6.2-4.92l15.4-29.71v25.7a5.79 5.79 0 0011.58 0V21.56a5.78 5.78 0 00-11.16-2.14l-.09.14L54.9 48.73l-3.71 7.8 2.68-9.69V10.26C73.8 6.93 92.32 3.81 92.32 3.81s4.9-1.19 5.2 4L97.3 10c1.68-.36 9.6-1.73 10.14 5l-1.11 16s1.36 1 7.27-1.32c0 0 8.31-3.3 9.2 4.94 0 0 1.61 8.44-9.35 12.18zm3.4-9.72a2.57 2.57 0 11-2.57-2.57 2.57 2.57 0 012.57 2.54z","fill":"#2172b9"}})])
          )
        }
      }
    